module.exports = __webpack_public_path__ + "static/standalone/img/logo_monogram.135b7c6e.svg";